<template>
  <layout-basic>
    <be-table
      :fields="fields"
      :actions="actions"
      card-name="Users"
      base-url="users"
      :disable-hidden-filter="true"
      :header-buttons="buttons"
      :refresh="refreshData"
      :custom-cells="customCells"
      @refreshed="refreshData = false"
    />
    <be-create-edit-modal
      v-if="readyToRenderModal"
      v-model="userToEdit"
      modal-name="New User"
      :fields="modalFields"
      :open="modalOpen"
      url="users"
      :edit-mode="modalEditMode"
      @modal-closed="onModalClose"
    />
    <b-modal
      id="viber-invite-modal"
      title="Invite to Viber"
      :hide-footer="true"
      @hidden="refreshData=true"
    >
      <p>{{ viberInviteUrl }}</p>
    </b-modal>
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import UserModal from "@/components/UserModal";
  import BeTable from "../components/crud/BeTable";
  import BeCreateEditModal from "../components/crud/BeCreateEditModal";
  import {required, email} from "vuelidate/lib/validators";

  export default {
    name: "Users",
    components: {
      LayoutBasic,
      BeTable,
      BeCreateEditModal
    },
    data() {
      return {
        fields: [
          "firstName",
          "lastName",
          "email",
          "position",
          {key: "enabled", label: "Enabled?"},
          {
            key: "actions",
            label: "",
            thClass: "tb-col-narrow"
          }
        ],
        customCells:[
          {
            key: 'enabled',
            callback: (item)=> {return item.enabled? 'Yes': 'No'}
          }
        ],
        buttons: [],
        actions: [],
        refreshData: true,
        modalFields: [],
        modalOpen: false,
        userToEdit: null,
        modalEditMode: false,
        viberInviteUrl: '',
        roles: [],
        readyToRenderModal: false
      };
    },
    async created() {
      let vm = this;
      try{
        vm.roles = (await vm.$http.get('roles')).data;
      }catch(error){
        vm.handleErrorResponse(error);
      }
      this.buttons = [
        {
          title: '+ New User',
          variant: 'primary',
          callback: function () {
            vm.modalOpen = true
          }
        }
      ];
      this.actions = [
        {
          class: 'table-edit',
          icon: 'fa fa-external-link-alt',
          callback: async function (item) {
            try{
              vm.userToEdit = item;
              vm.userToEdit.roles = (await vm.$http.get(`users/${item.id}/roles`)).data
              vm.modalEditMode = true;
              vm.modalOpen = true
            }catch(error){
              vm.handleErrorResponse(error);
            }
          }
        },
        {
          class: 'table-viber',
          icon: 'fab fa-viber',
          classCallback: (item) => item.viberId ? "table-viber text-success" : "table-viber text-secondary",
          callback: async function (item) {
            try {
              let response = await vm.$http.get(`users/${item.id}/viber`);
              vm.viberInviteUrl = response.data.url
              vm.$bvModal.show('viber-invite-modal')
            } catch (error) {
              vm.handleErrorResponse(error);
            }
          }
        },
        {
          class: 'table-delete',
          icon: 'fa fa-trash-alt',
          callback: async function (item) {
            try {
              let confirmation = await vm.$bvModal.msgBoxConfirm('Are you sure you want to delete this user?', {
                okVariant: 'danger',
                okTitle: 'Delete',
              });
              if (!confirmation) return;
              await vm.$http.delete(`users/${item.id}`)
            } catch (error) {
              vm.handleErrorResponse(error)
              return
            }
            vm.successAlert('The user was successfully deleted.')
            vm.refreshData = true
          }
        }
      ]
      this.modalFields = [
        {
          name: "firstName",
          label: "First Name",
          type: "text",
          placeholder: "Enter first name",
          validations: {required},
          validationError: "User first name is required"
        },
        {
          name: "lastName",
          label: "Last Name",
          type: "text",
          placeholder: "Enter last name",
          validations: {required},
          validationError: "User last name is required"
        },
        {
          name: "email",
          label: "Email",
          type: "text",
          placeholder: "Enter email",
          validations: {required,email},
          validationError: "Please enter a valid email address"
        },
        {
          name: "position",
          label: "Position",
          type: "text",
          placeholder: "Enter position",
          validations: {},
        },
        {
          name: "roles",
          label: "Roles",
          type: "multiselect",
          values: vm.roles,
          placeholder: "Roles",
          validations: {},
        },
        {
          name: "enabled",
          label: "Enabled?",
          type: "checkbox",
          englishOptions: true,
          validations: {},
          validationError: ""
        },
      ]
      vm.readyToRenderModal = true;
    },

    methods: {
      onModalClose() {
        this.modalOpen = false
        this.modalEditMode = false
        this.userToEdit = null
        this.refreshData = true
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-body {
    padding: 0px;
  }

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    &:not(:first-child) {
      margin-left: 12px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  h4 {
    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }

  .search-field {
    flex-basis: 25%;

    @include media-breakpoint-down(sm) {
      flex-basis: auto;
      flex-grow: 1;
      width: auto;
      order: 1;
    }
  }

  /deep/ .tb-col-narrow {

    width: 90px !important;

  }

  .table-edit {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $info;
    }
  }

  .table-delete {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $danger;
    }
  }

.table-viber {
    margin-left: 3px;
    margin-right: 3px;
  }

  #viber-invite-modal{
    p{
      word-break: break-all;
    }
  }
</style>